import type { IProductData } from '../../types/affiliates.types';
import type { CpHandler, IProductCard } from './productCard';
import wbdProductCard from './wbdProductCard';
import defaultProductCard from './defaultProductCard';

export type { CpHandler, IProductCard, IProductCardProps, IProductLogo } from './productCard';

const CUSTOM_CPS: Record<string, CpHandler> = {
  wbd: wbdProductCard
};

const getCpCard = (cp: string): CpHandler => CUSTOM_CPS[cp] || defaultProductCard;

const cardOrder = (card: IProductCard) => Math.min(...card.products.map(product => product.orderUI ?? Infinity));

export function buildProductCards(products: IProductData[]): IProductCard[] {
  const productsByCp = products.reduce<Record<string, IProductData[]>>(
    (grouped, product) => ({ ...grouped, [product.cps]: [...(grouped[product.cps] || []), product] }),
    {}
  );

  return Object.entries(productsByCp)
    .flatMap(([cp, cpProducts]) => getCpCard(cp)(cpProducts))
    .sort((a, b) => cardOrder(a) - cardOrder(b));
}
